import type { ReactNode } from 'react';

import { IllustratedEmptyState } from '@/components/illustrated-empty-state';
import { EMPTY_CALENDAR_ILLUSTRATION } from '@/lib/constants';

type EmptyCalendarStateProps = {
  title: string;
  description: ReactNode;
  primaryAction?: ReactNode;
  className?: string;
};

export const EmptyCalendarState = (props: EmptyCalendarStateProps) => (
  <IllustratedEmptyState
    {...props}
    illustration={EMPTY_CALENDAR_ILLUSTRATION}
    illustrationClassName="-scale-x-100"
  />
);
